import { render, staticRenderFns } from "./ConfirmRegistrationComponent.vue?vue&type=template&id=66c25bf5"
import script from "./ConfirmRegistrationComponent.vue?vue&type=script&lang=js"
export * from "./ConfirmRegistrationComponent.vue?vue&type=script&lang=js"
import style0 from "./ConfirmRegistrationComponent.vue?vue&type=style&index=0&id=66c25bf5&prod&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports